import {
  Book,
  Columns2,
  Facebook,
  Heading1,
  Heading2,
  Heading3,
  Image,
  Instagram,
  Link,
  Linkedin,
  List,
  ListOrdered,
  ListTodo,
  Minus,
  Music,
  Pen,
  Quote,
  SquareCode,
  Table,
  Twitch,
  Twitter,
  Youtube,
} from "lucide-react";
import { Group } from "./types.js";
import i18next from "i18next";

export const GROUPS: Group[] = [
  {
    name: "draft",
    title: i18next.t("draftWithAI") || "Draft with AI",
    commands: [
      {
        name: "brainstorm",
        label: i18next.t("brainstormIdeas") || "Brainstorm Ideas...",
        icon: Pen,
        description: i18next.t("brainstormIdeasDesc") || "Brainstorm ideas on ",
        action: (editor) => {
          //  "Brainstorm ideas on "
          return "Brainstorm ideas on ";
          // editor.chain().focus().setHeading({ level: 1 }).run();
        },
      },
      {
        name: "blog",
        label: i18next.t("blogPost") || "Blog post...",
        description: i18next.t("blogPostDesc") || "Blog post",
        action: (editor) => {
          return "Write a blog post about ";

          //  "Write a blog post about "
          // editor.chain().focus().setHeading({ level: 1 }).run();
        },
        icon: Pen,
      },
      {
        name: "outline",
        label: i18next.t("outline") || "Outline...",
        description: i18next.t("outlineDesc") || "Outline",
        action: (editor) => {
          return "Write an outline about ";
          // editor.chain().focus().setHeading({ level: 1 }).run();
        },
        icon: Pen,
      },

      {
        name: "social",
        label: i18next.t("socialMediaPost") || "Social Media post...",
        icon: Pen,
        description: i18next.t("socialMediaPostDesc") || "Social Media post",
        action: (editor) => {
          return;
          ("Write a social media post about ");
          // editor.chain().focus().setHeading({ level: 1 }).run();
        },
      },
      {
        name: "press",
        label: i18next.t("pressEelease") || "Press release...",
        icon: Pen,
        description: i18next.t("pressEeleaseDesc") || "Press release",
        action: (editor) => {
          return "Write a press release about ";
          // editor.chain().focus().setHeading({ level: 1 }).run();
        },
      },
      {
        name: "creative",
        label: i18next.t("creativeStory") || "Creative Story...",
        description: i18next.t("creativeStoryDesc") || "Creative Story",
        action: (editor) => {
          return "Write a creative story about ";
          // editor.chain().focus().setHeading({ level: 1 }).run();
        },
        icon: Pen,
      },
      {
        name: "essay",
        label: i18next.t("essay") || "Essay...",
        description: i18next.t("essayDesc") || "Essay",
        action: (editor) => {
          return "Write an essay about ";
          // editor.chain().focus().setHeading({ level: 1 }).run();
        },
        icon: Pen,
      },
    ],
  },
];

export default GROUPS;
